import type { FC } from 'react';
import React from 'react';
import { Box, Heading } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';

import DoublePill from '@/components/FlightSummary/HotelVoucher/DoublePill';
import LocationPill from '@/components/FlightSummary/HotelVoucher/LocationPill';

interface TopSectionProps {
  amountNights: number;
  destinationName: string;
}

const PillsSection: FC<TopSectionProps> = ({
  amountNights,
  destinationName,
}) => {
  const { t } = useTranslation();

  return (
    <Box position="relative" sx={{ transform: 'translate(0, -12px)' }}>
      <Box maxWidth="160px" mb="minus_small">
        <LocationPill
          amountNights={amountNights}
          destinationName={destinationName}
        />
      </Box>
      <Box position="absolute" sx={{ top: 0, right: 0 }}>
        <DoublePill
          alignment="end"
          firstPill={{
            render: (
              <Heading type="6" weight="medium" color="primary.90">
                {t('voucher.hotel.ribbon.text')}
              </Heading>
            ),
            sx: {
              borderRadius: '2px',
              boxShadow: '0px 2.21039px 8.84156px rgba(0, 0, 0, 0.23)',
              py: '3px',
              pr: 'base',
            },
          }}
          secondPill={{
            render: (
              <Heading type="6" weight="medium">
                {t('voucher.discount.ribbon.text')}
              </Heading>
            ),
            sx: {
              borderRadius: '2px',
              boxShadow: '0px 2.21039px 13.2623px rgba(0, 0, 0, 0.1)',
              pr: 'base',
              borderTopLeftRadius: 0,
              py: 'tiny',
            },
          }}
        />
      </Box>
    </Box>
  );
};

export default PillsSection;
